// extracted by mini-css-extract-plugin
export default {"page":"sQ-z","cartModal":"tQ-z","checkout":"uQ-z","placeholder":"vQ-z","account":"wQ-z"};